if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			this.pickupAvailabilityCompact = this.querySelector('pickup-availability-compact');
			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							this._pauseAllMedia();
							this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('navigation', e=>{
					this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`));
				})
				this.productSlider.addEventListener('change', e=>{
					this._pauseAllMedia();
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{
					
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}

					const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
					const productFigures = this.querySelectorAll('.apply-gallery-animation');
					this.productSlider.addEventListener('scroll', ()=>{
						const scrollX = -this.productSlider.element.scrollLeft;
						productSlides.forEach((slide,i)=>{
							const media = productFigures[i];
							if ( media ) {
								media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
							}
						});
					});

				});

			}

			// Product variant event listener for theme specific logic

			this.productVariantsAll = this.querySelectorAll('product-variants');
            this.productVariantsAll.forEach(el => {
              el.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
              this.onVariantChangeHandler({target:el});
              
            })

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}

			// update secondary price if present

			this.priceCompactAll = this.querySelectorAll('[data-js-product-price-compact]');
			this.priceExtendedAll = this.querySelectorAll('[data-js-product-price-extended]');
		

		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {
				
				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				}

				// refresh pickup availability widgets

				if ( this.pickupAvailabilityCompact && this.pickupAvailabilityCompact.classList.contains('active') ) {
					this.querySelector('pickup-availability-compact').style.display = 'block';
					this.querySelector('pickup-availability-compact').fetchAvailability(variant.id);
				}

				if ( this.pickupAvailabilityExtended && this.pickupAvailabilityExtended.classList.contains('active') ) {
					this.querySelector('pickup-availability-extended').style.display = 'block';
					this.querySelector('pickup-availability-extended').fetchAvailability(variant.id);
				}

			} else {

				if ( this.pickupAvailabilityCompact && this.pickupAvailabilityCompact.classList.contains('active') ) {
					this.querySelector('pickup-availability-compact').style.display = 'none';
				}

				if ( this.pickupAvailabilityExtended && this.pickupAvailabilityExtended.classList.contains('active') ) {
					this.querySelector('pickup-availability-extended').style.display = 'none';
				}

			}

			// update prices (overwrites the framework)

            const priceCompactAll = this.priceCompactAll || []
            priceCompactAll.forEach(el => {
                const priceOriginal = el.querySelector('[data-js-product-price-original]')
                const priceCompare = el.querySelector('[data-js-product-price-compare]')
                const priceUnit = el.querySelector('[data-js-product-price-unit]')
                    
				if ( !variant ) {
					priceOriginal.innerHTML = '';
					priceCompare.innerHTML = '';
					priceUnit.innerHTML = '';
				} else {
					const variantPrice = variant.price
					const variantCompareAtPrice = variant.compare_at_price
					
					priceOriginal.innerHTML = this.productVariantsAll[0]._formatMoney(variantPrice, KROWN.settings.shop_money_format);
					if ( variant.compare_at_price > variant.price ) {
						priceCompare.innerHTML = this.productVariantsAll[0]._formatMoney(variantCompareAtPrice, KROWN.settings.shop_money_format);
					}

					if ( variant.unit_price_measurement ) {
						priceUnit.innerHTML = `
							${this.productVariantsAll[0]._formatMoney(variant.unit_price, KROWN.settings.shop_money_format)} / 
							${( variant.unit_price_measurement.reference_value != 1 ? variant.unit_price_measurement.reference_value + ' ' : '' )}
							${variant.unit_price_measurement.reference_unit}
						`;
					} else {
						priceUnit.innerHTML = '';
					}
				}
            })

            const priceExtendedAll = this.priceExtendedAll || []
            priceExtendedAll.forEach(el => {
                const priceOriginal = el.querySelector('[data-js-product-price-original]')
                const priceCompare = el.querySelector('[data-js-product-price-compare]')
                const priceUnit = el.querySelector('[data-js-product-price-unit]')

  				if ( !variant ) {
  					if (priceOriginal) priceOriginal.innerHTML = '';
  					if (priceCompare) priceCompare.innerHTML = '';
  					if (priceUnit) priceUnit.innerHTML = '';
  				} else {
						const variantPrice = variant.price
						const variantCompareAtPrice = variant.compare_at_price
						 
   					if (priceOriginal) priceOriginal.innerHTML = this.productVariantsAll[0]._formatMoney(variantPrice, KROWN.settings.shop_money_format);
  					if ( variant.compare_at_price > variant.price ) {
   						if (priceCompare) priceCompare.innerHTML = `<span>${this.productVariantsAll[0]._formatMoney(variantCompareAtPrice, KROWN.settings.shop_money_format)}</span><span>${KROWN.settings.locales.product_compare_price.replace('$SAVE_PRICE', this.productVariantsAll[0]._formatMoney(variantCompareAtPrice - variantPrice, KROWN.settings.shop_money_format))}</span>`;
  					} else {
  						if (priceCompare) priceCompare.innerHTML = '';
  					}
  
  					if ( variant.unit_price_measurement ) {
  						if (priceUnit) priceUnit.innerHTML = `
  							${this.productVariantsAll[0]._formatMoney(variant.unit_price, KROWN.settings.shop_money_format)} / 
  							${( variant.unit_price_measurement.reference_value != 1 ? variant.unit_price_measurement.reference_value + ' ' : '' )}
  							${variant.unit_price_measurement.reference_unit}
  						`;
  					} else {
  						if (priceUnit) priceUnit.innerHTML = '';
  					}
  				}
              
            })

            // Custom code: calculator
            const priceKgAll = this.querySelectorAll('[data-js-product-price-kg]')

            priceKgAll.forEach(el => {
              const priceKgOriginal = el.querySelector('[data-js-product-price-kg-original]');
              const priceKgCompare = el.querySelector('[data-js-product-price-kg-compare]');
              if ( !variant ) {
                  priceKgOriginal.innerHTML = '';
                  priceKgCompare.innerHTML = '';
              } else {
                  const optionforKgValue = variant.options.find(opt => !isNaN(opt))
                  const kg = Number(optionforKgValue)
                  if (typeof optionforKgValue != 'undefined') {
 											const variantPrice = variant.price
											const variantCompareAtPrice = variant.compare_at_price
											 
                       priceKgOriginal.innerHTML = this.productVariantsAll[0]._formatMoney(variantPrice / kg, KROWN.settings.shop_money_format);
                      if ( variant.compare_at_price > variant.price ) {
 												priceKgCompare.innerHTML = `<span>${this.productVariantsAll[0]._formatMoney(variantCompareAtPrice / kg, KROWN.settings.shop_money_format)}</span>`;
                      } else {
                          priceKgCompare.innerHTML = '';
                      }
                  }
              }
              
            })
          

		}

		_pauseAllMedia(){

			document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
			document.querySelectorAll('.product-gallery product-model').forEach(model => {
				if ( model.modelViewerUI ) 
					model.modelViewerUI.pause()
			});
		}
		
		_playMedia(media){
			switch ( media.dataset.productMediaType ) {
				case 'video':
					if ( media.querySelector('video') ) {
						media.querySelector('video').play();
					}
					break;
				case 'external_video-youtube':
					if ( media.querySelector('.js-youtube') ) {
						media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					}
					break;
				case 'external_video-vimeo':
					if ( media.querySelector('.js-vimeo') ) {
						media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
					}
					break;
			}
		}

	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}